/**
 * AR-7737: Service Catalog publish requests are autom approvements of the Service automation type
 * (same id as the environment side). Approve/reject keeps sending bot_type 'autom'.
 */
export const SERVICE_CATALOG_AUTOMATION_TYPE_ID = '45f0c4d1-b228-410b-b9ae-79c9cdc699fe';

/** Translation key for a row's type label, or null to show the raw bot_type. */
export function approvementTypeLabelKey(row) {
    if (row && row.bot_type === 'autom' && row.automation_type_id === SERVICE_CATALOG_AUTOMATION_TYPE_ID) {
        return 'CONTENT.PUBLISH-APPROVE.TYPE-SERVICE';
    }
    return null;
}
